import React from 'react';
import Viewer from 'viewerjs';
import {post} from '../../utils/request';
import api from './api';
import './index.less';
import 'viewerjs/dist/viewer.css';
//添加水印
import watermark from 'watermark-dom';

class geelyNoticeDetail extends React.Component {
  constructor(props) {
    super(...props);
    this.state = {
        data:[],
        urlOps: {}
    }
  }
  componentWillMount() {
    
    var obj = '',obj1 = '',ops={};
    if(window.location.hash.indexOf('?') > -1 ){
        obj = window.location.hash.split('?')[1];
        obj1 = obj.split('&');
        for(var i=0;i<obj1.length;i++){
            ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
        }
        const {access_token} = ops;
        this.setState({
          urlOps: ops
        },()=>{
          post({
            url: api.view,
            data:{
              contentId: ops.id
            },
            preventXXSKey: 'contentRemark'
          }).then((res) => {
              // Toast.info(res.msg,1);
              if(res.result === 'success'){
                document.getElementsByTagName('title')[0].text = res.data.contentTitle;
                
                this.setState({
                  data: res.data
                });
              }else{
              }
          }, (res)=>{
              console.log('查询公告详情失败', res)
          });
        });
    }
  }
  componentDidMount(){
    new Viewer(document.getElementById('geelyNoticeDetailBox'), {
      navbar:false,
      toolbar: false,
      title: false,
      url: 'data-original'
    });
  }
  
  render() {
    const {data, urlOps} = this.state;
    
    if(urlOps.userName){
      watermark.load({
        watermark_txt: `${decodeURI(urlOps.userName)}/${urlOps.jobCard}`,
        watermark_x:-15,                     //水印起始位置x轴坐标
        watermark_y:0,                     //水印起始位置Y轴坐标
        watermark_x_space:20,              //水印x轴间隔
        watermark_y_space:70,               //水印y轴间隔
        watermark_color:'#000',//"#001529",
        watermark_fontsize:'12px',
        watermark_width: 110,
        watermark_alpha: 0.15,
        watermark_height: 18,
        // watermark_parent_node:'geelyNoticeBox'
      });
    }
    
    return (
      <div className="geelyNoticeDetailBox" id="geelyNoticeDetailBox">

          <h1>{data.contentTitle}</h1>
          <div className="source">
              <span className="author">{data.contentSource}</span>
              <span>{data.gmtCreate}</span>
              <span>{data.contentAttr}</span>
          </div>
          <div className="content" dangerouslySetInnerHTML={{__html: data.contentRemark}}></div>
      </div>
    );
  }
}

export default geelyNoticeDetail;


// WEBPACK FOOTER //
// ./src/geelyNotice/detail/index.js